const format = function (num) {
  if (num < 0) {
    num = -num
  }
  return num.toString()
}

const unsign = function (value) {
  if (isNaN(value)) {
    return value
  }
  return format(value)
}

export default unsign
